export default __webpack_public_path__ + "static/media/us.c2750ed9.svg";